import { render, staticRenderFns } from "./F2FDetailsModal.vue?vue&type=template&id=0034dd1e"
import script from "./F2FDetailsModal.vue?vue&type=script&lang=js"
export * from "./F2FDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./F2FDetailsModal.vue?vue&type=style&index=0&id=0034dd1e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports